import { useQuery } from '@tanstack/react-query';
import { api, type Channel, type Me, type Stream, type Usage } from './api';

export const useMe = () => useQuery({ queryKey: ['me'], queryFn: () => api<Me>('/v1/me'), staleTime: 60_000 });

export const useUsage = (days = 30, enabled = true) =>
  useQuery({ queryKey: ['usage', days], queryFn: () => api<Usage>(`/v1/usage?days=${days}`), refetchInterval: 60_000, enabled });

export const useStreams = (enabled = true) =>
  useQuery({
    queryKey: ['streams'],
    queryFn: () => api<{ data: Stream[]; has_more: boolean }>('/v1/streams?limit=100'),
    refetchInterval: 5_000,
    enabled,
  });

export const useChannels = (enabled = true) =>
  useQuery({
    queryKey: ['channels'],
    queryFn: () => api<{ data: Channel[]; has_more: boolean }>('/v1/channels?limit=100'),
    refetchInterval: 5_000,
    enabled,
  });
